import { ChatIcon } from "@phosphor-icons/react/dist/csr/Chat";
import { CurrencyDollarIcon } from "@phosphor-icons/react/dist/csr/CurrencyDollar";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@volca/ui/components/ui/toggle-group";
import { SIDEBAR_VIEW, type SidebarView } from "./sidebar-view";

export const SidebarViewToggle = ({
  view,
  onViewChange,
}: {
  view: SidebarView;
  onViewChange: (view: SidebarView) => void;
}) => (
  <ToggleGroup
    variant="outline"
    spacing={0}
    aria-label="Sidebar view"
    value={[view]}
    onValueChange={(next) => {
      const value = Object.values(SIDEBAR_VIEW).find(
        (option) => option === next[0],
      );
      if (value) onViewChange(value);
    }}
    className="shrink-0"
  >
    <ToggleGroupItem value={SIDEBAR_VIEW.preview}>
      <CurrencyDollarIcon data-icon="inline-start" />
      Pay
    </ToggleGroupItem>
    <ToggleGroupItem value={SIDEBAR_VIEW.history}>
      <ChatIcon data-icon="inline-start" />
      Notes & history
    </ToggleGroupItem>
  </ToggleGroup>
);
